import type { ReactNode } from 'react'

/**
 * Shared minimal shell for status/error pages (404, 500, 403, ...): a large
 * status code, a single line of copy, and action buttons. The root shell
 * still wraps this in the normal Header/Footer chrome.
 */
export function StatusPage({
  code,
  title,
  children,
}: {
  code: string | number
  title: string
  children?: ReactNode
}) {
  return (
    <main className="mx-auto flex min-h-[60vh] w-full max-w-5xl flex-col items-center justify-center gap-6 px-4 py-24 text-center">
      <span
        aria-hidden
        className="text-[6rem] leading-none font-bold tracking-tight text-primary/15 sm:text-[8rem]"
      >
        {code}
      </span>
      <h1 className="-mt-6 text-2xl font-bold tracking-tight text-balance sm:-mt-8 sm:text-3xl">
        {title}
      </h1>
      <div className="flex flex-wrap items-center justify-center gap-3">
        {children}
      </div>
    </main>
  )
}
